import { render, staticRenderFns } from "./RegistrationSuccess.vue?vue&type=template&id=4b119110&scoped=true&"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSuccess.vue?vue&type=style&index=0&id=4b119110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b119110",
  null
  
)

export default component.exports